import { useState, useEffect } from 'react';
import { collection, getDocs, query } from 'firebase/firestore';
import { firestore } from '../../../lib/firebase/config';
import { Verification } from '../../../types/verification';
import { useLanguage } from '../../../contexts/LanguageContext';
import toast from 'react-hot-toast';

export const useVerificationData = () => {
  const { translations } = useLanguage();
  const [verifications, setVerifications] = useState<Verification[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVerifications = async () => {
      setLoading(true);
      try {
        const verificationsRef = collection(firestore, 'verifications');
        const querySnapshot = await getDocs(verificationsRef);
        const fetchedVerifications: Verification[] = [];

        for (const doc of querySnapshot.docs) {
          const userRef = collection(
            firestore,
            doc.data().userType === 'guide' ? 'Guides' : 'Organizers'
          );
          const userQuery = query(userRef);
          const userSnapshot = await getDocs(userQuery);
          const userData = userSnapshot.docs
            .find((userDoc) => userDoc.id === doc.data().userId)
            ?.data();

          fetchedVerifications.push({
            id: doc.id,
            ...doc.data(),
            userName: userData?.name || doc.data().userName,
          } as Verification);
        }

        setVerifications(
          fetchedVerifications.sort((a, b) => b.createdAt - a.createdAt)
        );
      } catch (error) {
        console.error('Error fetching verifications:', error);
        toast.error(
          translations?.verificationApproval?.errors?.fetchFailed ||
            'Failed to load verifications'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchVerifications();
  }, [translations]);

  return { verifications, setVerifications, loading };
};